import React, { Fragment, FunctionComponent, useEffect, useState } from 'react';
import { ApplicationState } from '../../../redux/States';
import { ErrorDispatches } from '../../../redux/Dispatches';
import { ConnectedProps, connect } from 'react-redux';
import { Cell, Row, downloadSheets, generateSheet } from '../../../utils';
import XLSX, { Range } from 'xlsx-js-style';
import { Row as BSRow, Table, DropdownButton, Dropdown } from 'react-bootstrap';
import { AuthedLayout } from '../../../components';
import { useSemGrade } from '../../../hook';
import apis from '../../../apis';
import { SightMatrix } from '../../../apis/NoticeApi';
import { UserInfo } from '../../../model';
import { toast } from 'react-toastify';

const borderStyle = { color: { rgb: '000000' }, style: 'thin' } as const;
const fullBorderStyle = {
  top: borderStyle,
  bottom: borderStyle,
  left: borderStyle,
  right: borderStyle,
} as const;

const ratefontsize = {
  sz: 11
} as const

const cellAlignStyle = {
  horizontal: 'center',
  vertical: 'center',
} as const;

const mapState = (state: ApplicationState) => ({ ...state.auth });
const mapDispatches = ErrorDispatches;

const connector = connect(mapState, mapDispatches);

type Props = ConnectedProps<typeof connector>;

const sightStaticRate2: FunctionComponent<Props> = ({ catchErrorForModal }) => {
  const { yearSem, element } = useSemGrade();
  const [datas, setDatas] = useState<SightMatrix>([]);
  const [totalNoneCount, settotalNoneCount] = useState<Number>();
  const [totalCannotCount, settotalCannotCount] = useState<Number>();
  const [userinfo, setUser] = useState<UserInfo>();
  useEffect(() => {
    if (yearSem) {
      toast
        .promise(
          apis
            .getSightMatrix(yearSem.year, yearSem.sem)
            .then(r => {
              setDatas(r);
            }),
          {
            pending: '資料載入中......',
            success: '資料載入成功！',
            error: '資料載入失敗！請查看錯誤資訊。',
          }
        )
      apis.getUserInfo()
        .then((u) => {
          setUser(u);
        })
        .catch(catchErrorForModal);

    }
  }, [yearSem?.year, yearSem?.sem]);
  console.log(datas)

  const contentRows: Row[] = Object.values(datas).flatMap((d) => {
    return [
      {
        cells: [
          {
            value: d.grade === 0 ? '合計' : d.grade,
            style: { border: fullBorderStyle },
          },
          {
            value: d.allSum0 === 0 ? '0' : d.allSum0,
            style: { border: fullBorderStyle },
          },
          {
            value: d.maleSum0 === 0 ? '0' : d.maleSum0,
            style: { border: fullBorderStyle },
          },
          {
            value: d.femaleSum0 === 0 ? '0' : d.femaleSum0,
            style: { border: fullBorderStyle },
          },
          {
            value: d.male10 === 0 ? '0' : d.male10,
            style: { border: fullBorderStyle },
          },
          {
            value: d.female10 === 0 ? '0' : d.female10,
            style: { border: fullBorderStyle },
          },
          {
            value: d.male20 === 0 ? '0' : d.male20,
            style: { border: fullBorderStyle },
          },
          {
            value: d.female20 === 0 ? '0' : d.female20,
            style: { border: fullBorderStyle },
          },
          {
            value: d.male30 === 0 ? '0' : d.male30,
            style: { border: fullBorderStyle },
          },
          {
            value: d.female30 === 0 ? '0' : d.female30,
            style: { border: fullBorderStyle },
          },
          {
            value: d.male40 === 0 ? '0' : d.male40,
            style: { border: fullBorderStyle },
          },
          {
            value: d.female40 === 0 ? '0' : d.female40,
            style: { border: fullBorderStyle },
          },
          {
            value: d.maleSum01 - d.male20 - d.male30 - d.male40,
            style: { border: fullBorderStyle },
          },
          {
            value: d.femaleSum01 - d.female20 - d.female30 - d.female40,
            style: { border: fullBorderStyle },
          },
          {
            value: d.allSum01 === 0 ? '0' : d.allSum01,
            style: { border: fullBorderStyle },
          },
          {
            value: d.maleSum01 === 0 ? '0' : d.maleSum01,
            style: { border: fullBorderStyle },
          },
          {
            value: d.femaleSum01 === 0 ? '0' : d.femaleSum01,
            style: { border: fullBorderStyle },
          },
          {
            value: d.allSum1 === 0 ? '0' : d.allSum1,
            style: { border: fullBorderStyle },
          },
          {
            value: d.maleSum1 === 0 ? '0' : d.maleSum1,
            style: { border: fullBorderStyle },
          },
          {
            value: d.femaleSum1 === 0 ? '0' : d.femaleSum1,
            style: { border: fullBorderStyle },
          },
          {
            value: d.male11 === 0 ? '0' : d.male11,
            style: { border: fullBorderStyle },
          },
          {
            value: d.female11 === 0 ? '0' : d.female11,
            style: { border: fullBorderStyle },
          },
          {
            value: d.male21 === 0 ? '0' : d.male21,
            style: { border: fullBorderStyle },
          },
          {
            value: d.female21 === 0 ? '0' : d.female21,
            style: { border: fullBorderStyle },
          },
          {
            value: d.male31 === 0 ? '0' : d.male31,
            style: { border: fullBorderStyle },
          },
          {
            value: d.female31 === 0 ? '0' : d.female31,
            style: { border: fullBorderStyle },
          },
        ],
      },
      {
        cells: [
          {
            value: '比率',
            style: { border: fullBorderStyle },
          },
          {
            value: percent(d.allSum0, d.allSum0),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.maleSum0, d.allSum0),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.femaleSum0, d.allSum0),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.male10, d.maleSum0),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.female10, d.femaleSum0),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.male20, d.maleSum0),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.female20, d.femaleSum0),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.male30, d.maleSum0),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.female30, d.femaleSum0),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.male40, d.maleSum0),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.female40, d.femaleSum0),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent((d.maleSum01 - d.male20 - d.male30 - d.male40), d.maleSum0),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent((d.femaleSum01 - d.female20 - d.female30 - d.female40), d.femaleSum0),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.allSum01, d.allSum0),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.maleSum01, d.maleSum0),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.femaleSum01, d.femaleSum0),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.allSum1, d.allSum1),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.maleSum1, d.allSum1),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.femaleSum1, d.allSum1),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.male11, d.maleSum1),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.female11, d.femaleSum1),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.male21, d.maleSum1),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.female21, d.femaleSum1),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.male31, d.maleSum1),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
          {
            value: percent(d.female31, d.femaleSum1),
            style: { border: fullBorderStyle, font: ratefontsize },
          },
        ],
      },
    ];
  });

  const content: Row[] = [
    {
      cells: [
        {
          value: `一、合計人數不含視力之未測量（${datas[datas.length - 1]?.totalNoneCount ?? 0}筆）及無法測量（${datas[datas.length - 1]?.totalCannotCount ?? 0} 筆）。`,
          merge: { column: 26 },
          style: {
            border: { top: borderStyle, left: borderStyle, right: borderStyle },
            alignment: { horizontal: 'left' },
          },
        },
      ],
    },
    {
      cells: [
        {
          value:
            '二、表內【無法取得】意指裸眼視力欄位輸入為 -6（雷射治療）、-7（角膜塑型）、-8（戴隱形眼鏡）之代碼。',
          merge: { column: 26 },
          style: {
            border: { left: borderStyle, right: borderStyle },
            alignment: { horizontal: 'left' },
          },
        },
      ],
    },
    {
      cells: [
        {
          value: '三、以分組人數（分男女）為比率之母數。',
          merge: { column: 26 },
          style: {
            border: {
              bottom: borderStyle,
              left: borderStyle,
              right: borderStyle,
            },
            alignment: { horizontal: 'left' },
          },
        },
      ],
    },
    {
      cells: [
        {
          value: '年級',
          merge: { row: 4 },
          style: { border: fullBorderStyle },
        },
        {
          value: '裸視視力檢查人數',
          merge: { column: 16 },
          style: { border: fullBorderStyle },
        },
        {
          value: '戴鏡視力檢查人數',
          merge: { column: 9 },
          style: { border: fullBorderStyle },
        },
      ],
    },
    {
      cells: [
        { style: { border: fullBorderStyle } },
        {
          value: '',
          merge: { column: 3 },
          style: {
            border: { top: borderStyle, left: borderStyle, right: borderStyle },
          },
        },
        {
          value: '兩眼',
          merge: { column: 2 },
          style: {
            border: { top: borderStyle, left: borderStyle, right: borderStyle },
          },
        },
        {
          value: '裸視視力不良人數',
          merge: { column: 11 },
          style: { border: fullBorderStyle },
        },
        {
          value: '',
          merge: { column: 3 },
          style: {
            border: { top: borderStyle, left: borderStyle, right: borderStyle },
          },
        },
        {
          value: '兩眼',
          merge: { column: 2 },
          style: {
            border: { top: borderStyle, left: borderStyle, right: borderStyle },
          },
        },
        {
          value: '矯正視力不良',
          merge: { column: 4 },
          style: { border: fullBorderStyle },
        },
      ],
    },
    {
      cells: [
        { style: { border: fullBorderStyle } },
        {
          value: '合計',
          merge: { column: 3 },
          style: {
            border: {
              bottom: borderStyle,
              left: borderStyle,
              right: borderStyle,
            },
          },
        },
        {
          value: '均達0.9',
          merge: { column: 2 },
          style: {
            border: {
              bottom: borderStyle,
              left: borderStyle,
              right: borderStyle,
            },
          },
        },
        {
          value: '0.5 ~ 0.8',
          merge: { column: 2 },
          style: { border: fullBorderStyle },
        },
        {
          value: '0.1 ~ 0.4',
          merge: { column: 2 },
          style: { border: fullBorderStyle },
        },
        {
          value: '0.1 以下',
          merge: { column: 2 },
          style: { border: fullBorderStyle },
        },
        {
          value: '無法取得',
          merge: { column: 2 },
          style: { border: fullBorderStyle },
        },
        {
          value: '合計',
          merge: { column: 3 },
          style: { border: fullBorderStyle },
        },
        {
          value: '合計',
          merge: { column: 3 },
          style: {
            border: {
              bottom: borderStyle,
              left: borderStyle,
              right: borderStyle,
            },
          },
        },
        {
          value: '均達0.5',
          merge: { column: 2 },
          style: {
            border: {
              bottom: borderStyle,
              left: borderStyle,
              right: borderStyle,
            },
          },
        },
        {
          value: '0.1 ~ 0.4',
          merge: { column: 2 },
          style: { border: fullBorderStyle },
        },
        {
          value: '0.1 以下',
          merge: { column: 2 },
          style: { border: fullBorderStyle },
        },
      ],
    },
    {
      cells: [
        { style: { border: fullBorderStyle } },
        { value: '計', style: { border: fullBorderStyle } },
        { value: '男', style: { border: fullBorderStyle } },
        { value: '女', style: { border: fullBorderStyle } },
        { value: '男', style: { border: fullBorderStyle } },
        { value: '女', style: { border: fullBorderStyle } },
        { value: '男', style: { border: fullBorderStyle } },
        { value: '女', style: { border: fullBorderStyle } },
        { value: '男', style: { border: fullBorderStyle } },
        { value: '女', style: { border: fullBorderStyle } },
        { value: '男', style: { border: fullBorderStyle } },
        { value: '女', style: { border: fullBorderStyle } },
        { value: '男', style: { border: fullBorderStyle } },
        { value: '女', style: { border: fullBorderStyle } },
        { value: '計', style: { border: fullBorderStyle } },
        { value: '男', style: { border: fullBorderStyle } },
        { value: '女', style: { border: fullBorderStyle } },
        { value: '計', style: { border: fullBorderStyle } },
        { value: '男', style: { border: fullBorderStyle } },
        { value: '女', style: { border: fullBorderStyle } },
        { value: '男', style: { border: fullBorderStyle } },
        { value: '女', style: { border: fullBorderStyle } },
        { value: '男', style: { border: fullBorderStyle } },
        { value: '女', style: { border: fullBorderStyle } },
        { value: '男', style: { border: fullBorderStyle } },
        { value: '女', style: { border: fullBorderStyle } },
      ],
    },

    ...contentRows,
  ];

  const handlePrint = () => {
    const printWindow = window.open('', '_blank', 'width=1400,height=900');

    if (!printWindow) {
      alert('瀏覽器阻擋了列印視窗，請允許彈出式視窗。');
      return;
    }

    const escapeHtml = (value: unknown): string => {
      return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    };

    const tableHtml = content
      .map((row) => {
        const cells = row.cells
          .map((cell) => {
            if (cell.value === undefined) {
              return '';
            }

            const colSpan = cell.merge?.column
              ? ` colspan="${cell.merge.column}"`
              : '';

            const rowSpan = cell.merge?.row
              ? ` rowspan="${cell.merge.row}"`
              : '';

            const fontSize = cell.style?.font?.sz
              ? `font-size:${cell.style.font.sz}px;`
              : '';

            return `
            <td${colSpan}${rowSpan} style="${fontSize}">
              ${escapeHtml(cell.value)}
            </td>
          `;
          })
          .join('');

        return `<tr>${cells}</tr>`;
      })
      .join('');

    const title = `${yearSem?.year}學年第${yearSem?.sem}學期_視力統計表(含比率)`;

    printWindow.document.open();

    printWindow.document.write(`
    <!DOCTYPE html>
    <html lang="zh-Hant">
      <head>
        <meta charset="UTF-8" />
        <title>${escapeHtml(title)}</title>

        <style>
          * {
            box-sizing: border-box;
          }

          body {
            margin: 0;
            padding: 10px;
            font-family:
              "Microsoft JhengHei",
              "Noto Sans TC",
              Arial,
              sans-serif;
            color: #000;
          }

          h1 {
            margin: 0 0 10px;
            text-align: center;
            font-size: 16px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            table-layout: fixed;
          }

          td {
            border: 1px solid #000;
            padding: 3px 2px;
            text-align: center;
            vertical-align: middle;
            font-size: 8px;
            word-break: break-word;
          }

          .footer {
    margin-top: auto;
    padding-top: 16px;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    width: 100%;
}

          @page {
            size: A4 landscape;
            margin: 6mm;
          }

          @media print {
            body {
              padding: 0;
            }

            tr {
              page-break-inside: avoid;
            }
          }
        </style>
      </head>

      <body>
        <h1>${escapeHtml(title)}</h1>

        <table>
          <tbody>
            ${tableHtml}
          </tbody>
        </table>

        <div class="footer">
  <span>承辦人:</span>
  <span>組長:</span>
  <span>主任:</span>
  <span>校長:</span>
</div>

        <script>
          window.onload = function () {
            window.focus();

            setTimeout(function () {
              window.print();
            }, 300);
          };

          window.onafterprint = function () {
            window.close();
          };
        </script>
      </body>
    </html>
  `);

    printWindow.document.close();
  };

  return (
    <AuthedLayout>
      <BSRow className="justify-content-between">
        <span className="mr-3">{element}</span>
        <DropdownButton
          id="sight-static-rate2-export"
          title="匯出"
          variant="success"
          disabled={!datas.length}
        >
          <Dropdown.Item
            onClick={() => {
              const workSheet = generateSheet(
                [
                  {
                    cells: [
                      {
                        value: `${yearSem?.year}學年第${yearSem?.sem}學期_視力統計表(含比率)`,
                        style: {
                          alignment: {
                            horizontal: 'left',
                          },
                        },
                      },
                    ],
                  },
                  ...content,
                  {
                    cells: [
                      {
                        value:
                          '承辦人:　　　　　　　　　　　　　組長:　　　　　　　　　　　　　主任:　　　　　　　　　　　　　　校長:　　　　　　　　　　　　',
                        style: {
                          alignment: {
                            horizontal: 'left',
                          },
                        },
                      },
                    ],
                  },
                ],
                {
                  alignment: cellAlignStyle,
                }
              );

              downloadSheets(
                `${yearSem?.year}學年第${yearSem?.sem}學期_視力統計表(含比率)`,
                userinfo?.exportFileType,
                {
                  sheet: workSheet,
                  name: 'SightMatrix',
                }
              );
            }}
          >
            Excel 下載
          </Dropdown.Item>

          <Dropdown.Item onClick={handlePrint}>
            列印
          </Dropdown.Item>
        </DropdownButton>
      </BSRow>
      <hr />
      <BSRow>
        <Table
          striped
          bordered
          className="text-center"
          style={{ tableLayout: 'fixed' }}
        >
          <colgroup>
            <col style={{ width: '5%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '6%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
          </colgroup>
          <tbody>
            {content.map((r, i) => {
              const cells = r.cells.map((c, j) =>
                c.value != undefined ? (
                  <td
                    colSpan={c.merge?.column}
                    rowSpan={c.merge?.row}
                    key={`${i}-${j}`}
                    style={{ fontSize: c.style?.font?.sz }}
                  >
                    {c.value}
                  </td>
                ) : (
                  <Fragment key={`${i}-${j}`}></Fragment>
                )
              );
              return <tr key={i}>{cells}</tr>;
            })}
          </tbody>
        </Table>
      </BSRow>
    </AuthedLayout >
  );
};

function percent(value: number, denominator: number): string {
  if (!denominator) return '0.00%';
  return ((value / denominator) * 100).toFixed(2) + '%';
}

export const SightStaticRate2 = connector(sightStaticRate2);
